const Layout = () => import('@/layout/index.vue')

export default {
    path: '/operate',
    component: Layout,
    redirect: '/operate/customer',
    name: 'Operate',
    meta: {
        title: '运营配置',
        icon: 'operate'
    },
    children: [
        {
            path: 'customer',
            name: 'OperateCustomer',
            component: () => import('@/views/operate/customer/index.vue'),
            meta: {
                title: '客服配置',
                icon: 'operate-customer',
                auth: ['operate.customer']
            }
        },
        {
            path: 'pay',
            name: 'OperatePay',
            component: () => import('@/views/operate/pay/index.vue'),
            meta: {
                title: '付费套餐',
                icon: 'operate-pay',
                auth: ['operate.pay']
            }
        },
        {
            path: 'tag',
            name: 'OperateTag',
            component: () => import('@/views/operate/tag/index.vue'),
            meta: {
                title: '标签配置',
                icon: 'operate-tag',
                auth: ['operate.tag']
            }
        },
        {
            path: 'member',
            name: 'OperateMember',
            component: () => import('@/views/operate/member/index.vue'),
            meta: {
                title: '会员权益',
                icon: 'operate-member',
                auth: ['operate.member']
            }
        },
        {
            path: 'gifts',
            name: 'OperateGifts',
            component: () => import('@/views/operate/gifts/index.vue'),
            meta: {
                title: '会员礼包',
                icon: 'operate-gifts',
                auth: ['operate.gifts']
            }
        },
        {
            path: 'popup',
            name: 'OperatePopup',
            component: () => import('@/views/operate/popup/index.vue'),
            meta: {
                title: '弹窗配置',
                icon: 'operate-popup',
                auth: ['operate.popup']
            }
        },
        {
            path: 'navigation',
            name: 'OperateNavigation',
            component: () => import('@/views/operate/navigation/index.vue'),
            meta: {
                title: '运营导航',
                icon: 'operate-navigation',
                auth: ['operate.navigation']
            }
        },
        {
            path: 'ad',
            name: 'OperateAd',
            component: () => import('@/views/operate/ad/index.vue'),
            meta: {
                title: '广告管理',
                icon: 'operate-ad',
                auth: ['operate.ad']
            }
        },
        {
            path: 'video',
            name: 'OperateVideo',
            component: () => import('@/views/operate/video/index.vue'),
            meta: {
                title: '视频管理',
                icon: 'operate-video',
                auth: ['operate.video']
            }
        },
        {
            path: 'link',
            name: 'OperateLink',
            component: () => import('@/views/operate/link/index.vue'),
            meta: {
                title: '链接配置',
                icon: 'operate-link',
                auth: ['operate.link']
            }
        }, {
            path: 'functions',
            name: 'OperateFunctions',
            component: () => import('@/views/operate/functions/index.vue'),
            meta: {
                title: '功能管理',
                icon: 'operate-functions',
                auth: ['operate.functions']
            }
        }, {
            path: 'functionsBl',
            name: 'OperateFunctions2',
            component: () => import('@/views/operate/functions2/index.vue'),
            meta: {
                title: '功能管理(伴侣)',
                icon: 'operate-functions',
                auth: ['operate.functions']
            }
        }, {
            path: 'calendar',
            name: 'OperateCalendar',
            component: () => import('@/views/operate/calendar/index.vue'),
            meta: {
                title: '营销日历',
                icon: 'operate-calendar',
                auth: ['operate.calendar']
            }
        },
        {
            path: 'coupon',
            name: 'OperateCoupon',
            component: () => import('@/views/operate/coupon/index.vue'),
            meta: {
                title: '优惠券配置',
                icon: 'operate-coupon',
                auth: ['operate.coupon']
            }
        }
    ]
}
